import PanelLayout from './PanelLayout';
import connectContainer from './PanelLayoutContainer';

export default connectContainer(PanelLayout);
